module.exports = __webpack_public_path__ + "img/car4.5628a631.png";